import { Component, OnInit, Inject, OnDestroy, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { BaseComponent } from 'src/app/common/base/base.component';
import { UserCheck } from 'src/app/common/models/user-check';

@Component({
  selector: 'app-choos-users',
  templateUrl: './choose-users.component.html',
  styleUrls: ['./choose-users.component.scss']
})
export class ChooseUsersComponent extends BaseComponent implements OnInit, OnDestroy {

  usersFiltered!: UserCheck[];
  usersTable = new MatTableDataSource(this.users);
  loading = false;
  displayedColumns: string[] = ['choose', 'name', 'username', 'emailAddress'];
  selectedUsers: UserCheck[] = [];
  showSelected = false;

  constructor(
    protected override injector: Injector,
    public dialogRef: MatDialogRef<ChooseUsersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: number[]) {
    super(injector);
  }

  ngOnInit() {
    this.getUsers_();
  }

  toggleSelected() {
    this.showSelected = !this.showSelected
    // this.getUsers_();
    if (this.showSelected) {
      this.usersTable.data = this.selectedUsers;
    }
    else {
      this.usersTable.data = this.usersFiltered;
    }
  }

  getUsers_() {
    // Convert the list of pre‑selected IDs to a Set for O(1) look‑ups
    const preselectedIds = new Set(this.data);

    // Reset the selected‑users collection (avoid duplicates on re‑run)
    this.selectedUsers = [];

    // Build the filtered list immutably
    this.usersFiltered = this.getActiveUsers().map(raw => {
      const user = raw as UserCheck;
      const isChecked = !!user.id && preselectedIds.has(user.id);
      const enriched: UserCheck = { ...user, isCheck: isChecked };

      if (isChecked) {
        this.selectedUsers.push(enriched);
      }
      return enriched;
    });

    this.usersTable.data = this.usersFiltered;

    this.loading = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    this.dialogRef.close(this.selectedUsers);
  }

  checking(value: boolean, element: UserCheck) {
    if (value) {
      this.selectedUsers.push(element);
    } else {
      this.removeUser(element);
    }
  }

  // getRecord(row: UserCheck) {
  //   row.isCheck = !row.isCheck;
  //   if (row.isCheck) {
  //     this.selectedUsers.push(row);
  //   } else {
  //     this.removeUser(row);
  //   }
  // }

  removeUser(user: UserCheck) {
    const index: number = this.selectedUsers.indexOf(user);
    if (index >= 0)
      this.selectedUsers.splice(index, 1);
  }
}
